import { render, staticRenderFns } from "./PublicList.vue?vue&type=template&id=de895e2e&scoped=true"
import script from "./PublicList.vue?vue&type=script&lang=js"
export * from "./PublicList.vue?vue&type=script&lang=js"
import style0 from "./PublicList.vue?vue&type=style&index=0&id=de895e2e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de895e2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de895e2e')) {
      api.createRecord('de895e2e', component.options)
    } else {
      api.reload('de895e2e', component.options)
    }
    module.hot.accept("./PublicList.vue?vue&type=template&id=de895e2e&scoped=true", function () {
      api.rerender('de895e2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/allianceAuthorization/components/PublicList.vue"
export default component.exports